import React, { useState } from "react";
import { Button, Column, Columns, Modal, Section, Table, Title } from "@allxsmith/bestax-bulma";
import axios from "axios";
import { createSetDataFreshAction } from "../../actions/dataActions";
import { useDispatch, useSelector } from "react-redux";
import { getDataFresh } from "../../state/selectors";
import PaymentRow from "../Invoicing/PaymentRow";
import {ToastContainer, toast} from "react-toastify";
import * as shortid from "shortid";

export default function CreatePaymentModal({ open, setOpen, endpoint, departments, departmentObjects}) {
  const dispatch = useDispatch();
  let dataFresh = useSelector(getDataFresh);
  let [payments, setPayments] = useState([]);

  const onClickAction = () => {
    if (checkAllFieldsFilled()) {
      save();
      setPayments([]);
      setOpen(false);
    } else {
      toast.error("Please fill in all fields", {position: "top-right"});
    }
  };

  const handleChange = (e, index) => {
    let newPayments = [...payments];
    newPayments[index][e.target.name] = e.target.value;
    setPayments(newPayments);
  };

  const handleDelete = index => {
    const newPayments = [...payments];
    newPayments.splice(index, 1);
    setPayments(newPayments);
  };

  const checkAllFieldsFilled = () => {
    for (let i = 0; i < payments.length; i++) {
      let payment = payments[i];
      if (
        !payment.contact ||
        !payment.payment_date ||
        !payment.amount
      ) {
        return false;
      }
    }
    return true;
  };

  const save = () => {
    const url = endpoint + "payments";
    Promise.all(
      payments.map(payment => {
        const data = payment;
        const conf = {
          method: "post",
          data,
          url
        };

        return axios(conf).then(() => {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          setOpen(false);
        });
      })
    ).then(() => {
      return true;
    });
  };

  const addPaymentRow = () => {
    let newPayments = payments;
    let newPayment = { payment_type: "BACS", key: shortid.generate() };
    newPayments.push(newPayment);
    setPayments([...newPayments]);
  };

  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <Modal
      closeOnBlur
      active={open}
      onClose={() => {
        setPayments([]);
        setOpen(false);
      }}
    >
      <Modal.Content className="wider-modal">
        <Section style={{ backgroundColor: "white" }}>
          <Title className="is-centered">Create New Payments</Title>
          <Table>
            <thead>
              <tr>
                <th>Customer</th>
                <th>Department</th>
                <th>Invoice Number</th>
                <th>Payment Amount</th>
                <th>Payment Type</th>
                <th>Payment Date</th>
                <th>Comments</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((payment, index) => (
                <PaymentRow
                  endpoint={endpoint}
                  payment={payment}
                  index={index}
                  handleChange={handleChange}
                  handleDelete={handleDelete}
                  key={payment.key}
                  departments={departments}
                  departmentObjects={departmentObjects}
                />
              ))}
            </tbody>
          </Table>
          <Columns isMultiline>
            <Column>
              <Button color="primary" onClick={addPaymentRow}>
                Add Payment
              </Button>
            </Column>
          </Columns>
          <Columns isMultiline>
            <Column>
              <Button
                color="info"
                onClick={() => {
                  setPayments([]);
                  setOpen(false);
                }}
                isFullWidth
              >
                Cancel
              </Button>
            </Column>
            <Column>
              <Button color="danger" onClick={onClickAction} isFullWidth>
                Save Payments
              </Button>
            </Column>
          </Columns>
        </Section>
      </Modal.Content>
    </Modal>
  );
}
